'use strict';

module.exports = function () {
    $('body').on('click', '#myaccount', function () {
        var accountShowLink = $(this).attr('href');
        window.location.href = accountShowLink;
    });
};
